var React = require('react');

function Feedback (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"background","fill":"#E3F2FD","cx":"20","cy":"20","r":"20","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"className":"foreground","d":"M27.5 10h-15a2.5 2.5 0 0 0-2.5 2.495v11.228a2.5 2.5 0 0 0 2.5 2.495h3.75v3.275a.47.47 0 0 0 .746.378l4.879-3.653H27.5a2.5 2.5 0 0 0 2.5-2.495V12.495A2.5 2.5 0 0 0 27.5 10z","fill":"#2196F3","key":0}),React.createElement("path",{"d":"M24.457 16.386l-5.117 5.068a.429.429 0 0 1-.61-.004l-2.957-2.974a.43.43 0 0 1 .004-.609l1.016-1.005a.432.432 0 0 1 .61.003l1.644 1.657 3.797-3.758a.432.432 0 0 1 .61.004l1.007 1.014a.429.429 0 0 1-.004.604z","fill":"#90CAF9","key":1})])]));
}

Feedback.defaultProps = {"width":"40","height":"40"};

module.exports = Feedback;

Feedback.default = Feedback;
